import { IosShare } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import React from "react";

interface StoreInsightsPanelProps {
  title: React.ReactNode;
  onExport?: () => void;
  exportDisabled?: boolean;
  headerActions?: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
}

export const StoreInsightsPanel: React.FC<StoreInsightsPanelProps> = ({
  title,
  onExport,
  exportDisabled = false,
  headerActions,
  footer,
  children,
}) => {
  const showHeader = Boolean(title) || Boolean(onExport);

  return (
    <div className="bg-white p-6 rounded-2xl border border-blue-50 shadow-md shadow-blue-100 mt-4 w-full flex flex-col">
      {showHeader ? (
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-[20px] font-semibold text-[#001F3F]">{title}</h2>
          <div className="flex items-center gap-2">
            {headerActions}
            {onExport ? (
              <IconButton size="small" onClick={onExport} disabled={exportDisabled}>
                <IosShare
                  fontSize="small"
                  className={exportDisabled ? "text-gray-300" : "text-blue-500"}
                />
              </IconButton>
            ) : null}
          </div>
        </div>
      ) : null}
      <div className="overflow-x-auto flex-1">{children}</div>
      {footer}
    </div>
  );
};
